<template>
  <shell>
    <onboarding-sidebar class="relative z-10"/>

    <div class="fixed top-0 mt-5 lg:mt-10 w-full z-0">
        <Logo class="w-10 lg:w-12 ml-auto mr-10 lg:mr-auto lg:mx-auto" variant="logo-small"/>
    </div>

    <div class="w-full px-8 py-6 lg:px-24 lg:pb-16 lg:pt-48 max-w-screen-lg">
      <router-view/>
    </div>
  </shell>
</template>

<script>
import Shell from "@/modules/Auth/components/Shell";
import OnboardingSidebar from "../components/OnboardingSidebar";

export default {
  name: "OnboardingStepsPage",
  components: {
    OnboardingSidebar,
    Shell,
  },
};
</script>
